import { store } from "../../store";

export default () => {
    window.registerNextGenComponent = function(name, loader) {
        if (!window.nextGenComponents) {
            window.nextGenComponents = {};
        }
    
        window.nextGenComponents[name] = new loader();
    }

    window.updateNextGenCredentials = function(type, token, appSessionKey) {
        store.dispatch("auth/setCredentials", {
            type: type,
            token: token,
            appSessionKey: appSessionKey
        });
    }
    
    window.mountNextGenComponent = function(name, DOMElement, config) {
        if (typeof window.nextGenComponents[name] === "undefined") {
            throw new Error("Unrecognised component");
        }
    
        window.nextGenComponents[name].mount(DOMElement, config);
    }

    window.unmountNextGenComponent = function (name) {
        window.nextGenComponents[name].destroy();
    }
    
    
    window.updateNextGenComponent = function(name, config) {
        if (typeof window.nextGenComponents[name] === "undefined") {
            throw new Error("Unrecognised component");
        }
    
        window.nextGenComponents[name].update(config);
    }
}